import {api} from "./api.service";

export class CourseService {
    /**
     * Get all courses
     * @param {number} page - Page number for pagination
     * @param {number} limit - Number of items per page
     * @param {string} search - Search query
     * @returns {Promise} - Promise with course data
     */
    static async getAllCourses(page = 0, limit = 0, search = '') {
        const params = {};
        if (page) params['page'] = page;
        if (limit) params['limit'] = limit;
        if (search) params['search'] = search;

        return api.get(`course`, {params});
    }

    /**
     * Get a single course by ID
     * @param {string} id - Course ID
     * @returns {Promise} - Promise with course data
     */
    static async getCourseById(id) {
        return api.get(`course/${id}`);
    }

    /**
     * Track course video progress
     * @param {Object} payload - Progress tracking data
     * @returns {Promise} - Promise with tracking response
     */
    static async trackCourseVideoProgress(payload) {
        return api.post(`vault-watch-history`, payload);
    }

    /**
     * Get course categories
     * @returns {Promise} - Promise with categories data
     */
    static async getCourseCategories() {
        return api.get(`course/categories`);
    }
}
